/**
 * Constantes liées aux missions
 * Source de vérité unique — miroir du schéma Prisma
 */

export const MissionStatut = {
  BROUILLON: 'brouillon',
  DIFFUSEE: 'diffusee',
  ATTRIBUEE: 'attribuee',
  ANNULEE: 'annulee',
}

export const MISSION_STATUT_LABELS = {
  [MissionStatut.BROUILLON]: 'Brouillon',
  [MissionStatut.DIFFUSEE]: 'Diffusée',
  [MissionStatut.ATTRIBUEE]: 'Attribuée',
  [MissionStatut.ANNULEE]: 'Annulée',
  corbeille: 'Corbeille',
}

export const MISSION_STATUT_ICONS = {
  [MissionStatut.BROUILLON]: 'fas fa-clock',
  [MissionStatut.DIFFUSEE]: 'fas fa-bullhorn',
  [MissionStatut.ATTRIBUEE]: 'fas fa-user-check',
  [MissionStatut.ANNULEE]: 'fas fa-ban',
  corbeille: 'fas fa-trash',
}

export const MISSION_STATUT_BADGE_VARIANTS = {
  [MissionStatut.BROUILLON]: 'secondary',
  [MissionStatut.DIFFUSEE]: 'success',
  [MissionStatut.ATTRIBUEE]: 'info',
  [MissionStatut.ANNULEE]: 'danger',
  corbeille: 'secondary',
}

/** Le message facultatif au formateur (attribution, annulation) : la borne du serveur (mission-saisies.js). */
export const MESSAGE_FORMATEUR_MAX = 2000

export const MissionFormateurStatut = {
  SOLLICITE: 'sollicite',
  EMAIL_OUVERT: 'email_ouvert',
  DISPONIBLE: 'disponible',
  INDISPONIBLE: 'indisponible',
  ATTRIBUE: 'attribue',
  // Post-formation (LOT 6)
  FORMATION_TERMINEE: 'formation_terminee',
  FACTURE_RECUE: 'facture_recue',
  EMARGEMENT_VALIDE: 'emargement_valide',
  EMARGEMENT_A_VERIFIER: 'emargement_a_verifier',
  PAIEMENT_EFFECTUE: 'paiement_effectue',
  CLOTURE: 'cloture',
}

export const MISSION_FORMATEUR_STATUT_LABELS = {
  [MissionFormateurStatut.SOLLICITE]: 'Sollicité',
  [MissionFormateurStatut.EMAIL_OUVERT]: 'Email ouvert',
  [MissionFormateurStatut.DISPONIBLE]: 'Disponible',
  [MissionFormateurStatut.INDISPONIBLE]: 'Indisponible',
  [MissionFormateurStatut.ATTRIBUE]: 'Attribué',
  [MissionFormateurStatut.FORMATION_TERMINEE]: 'En attente de facture',
  [MissionFormateurStatut.FACTURE_RECUE]: 'Facture reçue',
  [MissionFormateurStatut.EMARGEMENT_VALIDE]: 'Émargement validé',
  [MissionFormateurStatut.EMARGEMENT_A_VERIFIER]: 'Émargement à vérifier',
  [MissionFormateurStatut.PAIEMENT_EFFECTUE]: 'Paiement effectué',
  [MissionFormateurStatut.CLOTURE]: 'Clôturé',
}

export const MISSION_FORMATEUR_STATUT_ICONS = {
  [MissionFormateurStatut.SOLLICITE]: 'fas fa-paper-plane',
  [MissionFormateurStatut.EMAIL_OUVERT]: 'fas fa-envelope-open',
  [MissionFormateurStatut.DISPONIBLE]: 'fas fa-check',
  [MissionFormateurStatut.INDISPONIBLE]: 'fas fa-times',
  [MissionFormateurStatut.ATTRIBUE]: 'fas fa-star',
  [MissionFormateurStatut.FORMATION_TERMINEE]: 'fas fa-hourglass-half',
  [MissionFormateurStatut.FACTURE_RECUE]: 'fas fa-file-invoice',
  [MissionFormateurStatut.EMARGEMENT_VALIDE]: 'fas fa-clipboard-check',
  [MissionFormateurStatut.EMARGEMENT_A_VERIFIER]: 'fas fa-exclamation-triangle',
  [MissionFormateurStatut.PAIEMENT_EFFECTUE]: 'fas fa-money-check-alt',
  [MissionFormateurStatut.CLOTURE]: 'fas fa-check-circle',
}

export const MISSION_FORMATEUR_STATUT_BADGE_VARIANTS = {
  [MissionFormateurStatut.SOLLICITE]: 'secondary',
  [MissionFormateurStatut.EMAIL_OUVERT]: 'info',
  [MissionFormateurStatut.DISPONIBLE]: 'success',
  [MissionFormateurStatut.INDISPONIBLE]: 'danger',
  [MissionFormateurStatut.ATTRIBUE]: 'success',
}

export const MISSION_FORMATEUR_STATUTS_REPONDABLES = [
  MissionFormateurStatut.SOLLICITE,
  MissionFormateurStatut.EMAIL_OUVERT,
  MissionFormateurStatut.DISPONIBLE,
  MissionFormateurStatut.INDISPONIBLE,
]

export const MISSION_FORMATEUR_STATUT_BADGE_CONFIG = {
  [MissionFormateurStatut.FORMATION_TERMINEE]: { label: 'En attente de facture', bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  [MissionFormateurStatut.FACTURE_RECUE]: { label: 'Facture reçue', bg: '#dbeafe', color: '#1d4ed8', border: '#3b82f6' },
  [MissionFormateurStatut.EMARGEMENT_VALIDE]: { label: 'Émargement validé', bg: '#d1fae5', color: '#065f46', border: '#10b981' },
  [MissionFormateurStatut.EMARGEMENT_A_VERIFIER]: { label: 'Émargement à vérifier', bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  [MissionFormateurStatut.PAIEMENT_EFFECTUE]: { label: 'Paiement effectué', bg: '#d1fae5', color: '#065f46', border: '#10b981' },
  [MissionFormateurStatut.CLOTURE]: { label: 'Clôturé', bg: '#f3f4f6', color: '#374151', border: '#9ca3af' },
}

/** Statuts post-formation (pour les filtres) */
export const POST_FORMATION_STATUTS = [
  MissionFormateurStatut.FORMATION_TERMINEE,
  MissionFormateurStatut.FACTURE_RECUE,
  MissionFormateurStatut.EMARGEMENT_VALIDE,
  MissionFormateurStatut.EMARGEMENT_A_VERIFIER,
  MissionFormateurStatut.PAIEMENT_EFFECTUE,
  MissionFormateurStatut.CLOTURE,
]

/* -------------------------------------------------------------------------- */
/*  CE QU'UN POSITIONNEMENT RÉPOND, VU PAR CELUI QUI A PUBLIÉ LA MISSION       */
/* -------------------------------------------------------------------------- */

/**
 * Le donneur d'ordre — le back-office par « Missionner un formateur », le
 * formateur publieur par « Réponses à ma mission » — ne lit pas le statut
 * technique d'un `MissionFormateur` : il lit UNE RÉPONSE. Les onze statuts se
 * ramènent donc à cinq, et ces cinq-là se nomment, se colorent et se rangent
 * de la même façon des deux côtés.
 *
 * Les trois tables vivaient en double, recopiées dans `MissionnerReponses.vue`
 * puis sur le point de l'être dans la page du portail. Deux copies d'un
 * vocabulaire, c'est deux vocabulaires : c'est ainsi que le back-office aurait
 * fini par dire « Sans réponse » là où le portail disait « Sollicité ».
 */
export function normaliserStatutReponse(statut) {
  return POST_FORMATION_STATUTS.includes(statut) ? MissionFormateurStatut.ATTRIBUE : statut
}

/**
 * « Sollicité » ne dit rien à qui attend une réponse : on nomme l'ATTENTE, pas
 * l'action déjà faite. De même « Attribué » se dit « Retenu » — c'est le geste
 * du donneur d'ordre, vu de son côté.
 */
export const MISSION_FORMATEUR_REPONSE_LABELS = {
  [MissionFormateurStatut.SOLLICITE]: 'Sans réponse',
  [MissionFormateurStatut.EMAIL_OUVERT]: 'Courriel ouvert',
  [MissionFormateurStatut.DISPONIBLE]: 'Disponible',
  [MissionFormateurStatut.INDISPONIBLE]: 'Indisponible',
  [MissionFormateurStatut.ATTRIBUE]: 'Retenu',
}

/** Variantes de `ListPill`, pas de `Badge` : ces réponses vivent dans des listes v2. */
export const MISSION_FORMATEUR_REPONSE_PILL_VARIANTS = {
  [MissionFormateurStatut.SOLLICITE]: 'neutral',
  [MissionFormateurStatut.EMAIL_OUVERT]: 'info',
  [MissionFormateurStatut.DISPONIBLE]: 'success',
  [MissionFormateurStatut.INDISPONIBLE]: 'danger',
  [MissionFormateurStatut.ATTRIBUE]: 'success',
}

/**
 * Rang de lecture par défaut : CE QUI APPELLE UNE DÉCISION PASSE DEVANT. Ce
 * n'est pas l'ordre alphabétique des statuts ni celui de la base, c'est
 * l'ordre dans lequel on a besoin de les voir quand on vient choisir.
 */
export const MISSION_FORMATEUR_REPONSE_RANG = {
  [MissionFormateurStatut.ATTRIBUE]: 0,
  [MissionFormateurStatut.DISPONIBLE]: 1,
  [MissionFormateurStatut.EMAIL_OUVERT]: 2,
  [MissionFormateurStatut.SOLLICITE]: 3,
  [MissionFormateurStatut.INDISPONIBLE]: 4,
}

/**
 * État dérivé d'une mission *du point de vue du formateur courant*. Ce n'est PAS
 * un statut persisté : il se calcule à partir de (mf.statut, mission.statut, date
 * de la mission). Source de vérité unique du pipeline « Missions pour vous » —
 * utilisé à la fois pour le bucketing (composable) et le rendu de la carte.
 */
export const FormateurEtat = {
  RECUE: 'recue',                 // sollicité, pas encore répondu → À traiter (formulaire)
  DISPONIBLE: 'disponible',       // a confirmé sa dispo, mission encore ouverte → En attente
  INDISPONIBLE: 'indisponible',   // a refusé, mission encore ouverte (modifiable) → À traiter
  GAGNEE: 'gagnee',               // la mission lui a été attribuée → Attribuées / Gagnées
  NON_RETENUE: 'non_retenue',     // était dispo mais attribuée à un autre / date passée sans validation
  CLOTUREE: 'cloturee',           // jamais répondu ou indispo, et mission attribuée ailleurs / passée / annulée
}

// Configuration des badges par état dérivé. Un état peut afficher plusieurs badges
// (ex: « disponible » = dispo confirmée + en attente de validation). `style` permet
// de nuancer les gris (non retenue ⚫ vs clôturée ⚪) que les variants Badge ne distinguent pas.
export const FORMATEUR_ETAT_BADGES = {
  [FormateurEtat.DISPONIBLE]: [
    { label: 'Disponibilité confirmée', variant: 'success', icon: 'fas fa-circle-check' },
    { label: 'En attente de validation', variant: 'warning', icon: 'fas fa-hourglass-half' },
  ],
  [FormateurEtat.INDISPONIBLE]: [
    { label: 'Mission refusée', variant: 'danger', icon: 'fas fa-circle-xmark' },
  ],
  [FormateurEtat.NON_RETENUE]: [
    { label: 'Non retenue', variant: 'secondary', icon: 'fas fa-circle', style: { background: '#e5e7eb', color: '#374151' } },
  ],
  [FormateurEtat.CLOTUREE]: [
    { label: 'Clôturée', variant: 'secondary', icon: 'fas fa-circle' },
  ],
}

/**
 * Dernière date de formation d'une mission (multi-dates → la plus tardive,
 * fallback sur le champ legacy `dateFormation`). Retourne un Date ou null.
 */
export function getDerniereDateMission(mission) {
  // Une mission en période n'a aucune date de jour : elle dure jusqu'à la fin de la période.
  if (mission?.modeDates === ModeDates.PERIODE && mission.periodeFin) {
    const fin = new Date(mission.periodeFin)
    if (!Number.isNaN(fin.getTime())) return fin
  }
  const dates = Array.isArray(mission?.datesFormation) ? mission.datesFormation : []
  const times = dates
    .map((d) => new Date(d?.date || d).getTime())
    .filter((t) => !Number.isNaN(t))
  if (times.length > 0) return new Date(Math.max(...times))
  if (mission?.dateFormation) {
    const t = new Date(mission.dateFormation)
    return Number.isNaN(t.getTime()) ? null : t
  }
  return null
}

/** Une mission est « passée » lorsque sa dernière date est strictement antérieure à aujourd'hui. */
export function isMissionPassee(mission, now = new Date()) {
  const last = getDerniereDateMission(mission)
  if (!last) return false
  const startOfToday = new Date(now)
  startOfToday.setHours(0, 0, 0, 0)
  return last < startOfToday
}

/**
 * Calcule l'état dérivé d'une mission pour le formateur courant.
 * @param {{ mf: object|null, mission: object, now?: Date }} args
 * @returns {string} une valeur de FormateurEtat
 */
export function deriveEtatFormateur({ mf, mission, now = new Date() }) {
  const statutMf = mf?.statut
  const statutMission = mission?.statut
  const passee = isMissionPassee(mission, now)

  // Gagnée : la mission m'a été attribuée (attribue + tout le cycle post-formation).
  if (statutMf === MissionFormateurStatut.ATTRIBUE || POST_FORMATION_STATUTS.includes(statutMf)) {
    return FormateurEtat.GAGNEE
  }

  // Mission attribuée à quelqu'un d'autre (sinon on serait passé en GAGNEE ci-dessus).
  if (statutMission === MissionStatut.ATTRIBUEE) {
    return statutMf === MissionFormateurStatut.DISPONIBLE
      ? FormateurEtat.NON_RETENUE
      : FormateurEtat.CLOTUREE
  }

  // Mission annulée : terminale côté formateur.
  if (statutMission === MissionStatut.ANNULEE) return FormateurEtat.CLOTUREE

  // Mission encore diffusée mais dont la dernière date est passée.
  if (passee) {
    return statutMf === MissionFormateurStatut.DISPONIBLE
      ? FormateurEtat.NON_RETENUE   // était dispo, jamais validée
      : FormateurEtat.CLOTUREE      // jamais répondu / indispo
  }

  // Mission diffusée, date à venir : état actif.
  if (statutMf === MissionFormateurStatut.DISPONIBLE) return FormateurEtat.DISPONIBLE
  if (statutMf === MissionFormateurStatut.INDISPONIBLE) return FormateurEtat.INDISPONIBLE
  return FormateurEtat.RECUE
}

export const MISSION_STATUT_BADGE_CONFIG = {
  brouillon:  { label: 'Brouillon',  bg: '#f3f4f6', color: '#374151', border: '#d1d5db' },
  diffusee:   { label: 'Diffusée',   bg: '#dbeafe', color: '#1d4ed8', border: '#3b82f6' },
  attribuee:  { label: 'Attribuée',  bg: '#d1fae5', color: '#065f46', border: '#10b981' },
  annulee:    { label: 'Annulée',    bg: '#fee2e2', color: '#991b1b', border: '#ef4444' },
  corbeille:  { label: 'Corbeille',  bg: '#f3f4f6', color: '#6b7280', border: '#9ca3af' },
}

export const MissionDiffusionMode = {
  AUTOMATIQUE: 'automatique',
  FILTREE: 'filtree',
  INDIVIDUELLE: 'individuelle',
  CARTE: 'carte',
}

export const MISSION_DIFFUSION_MODE_LABELS = {
  [MissionDiffusionMode.AUTOMATIQUE]: 'Automatique',
  [MissionDiffusionMode.FILTREE]: 'Filtrée',
  [MissionDiffusionMode.INDIVIDUELLE]: 'Individuelle',
  [MissionDiffusionMode.CARTE]: 'Carte',
}

export const ModeDates = {
  FIXES: 'fixes',
  CHOIX: 'choix',
  PERIODE: 'periode',
}

export const MODES_DATES = [
  {
    value: ModeDates.FIXES,
    label: 'Dates fixes',
    description: 'La formation se déroulera aux dates indiquées. Le formateur doit être disponible pour toutes ces dates.',
    icon: 'fas fa-calendar-check',
    testId: 'publier-mission-mode-fixes',
  },
  {
    value: ModeDates.CHOIX,
    label: 'Plusieurs dates possibles',
    description: 'Proposez plusieurs dates au choix. Le formateur cochera celles auxquelles il est disponible.',
    icon: 'fas fa-calendar-days',
    testId: 'publier-mission-mode-choix',
  },
  {
    value: ModeDates.PERIODE,
    label: 'Période de disponibilité',
    description: 'Définissez une période pendant laquelle la formation peut être organisée. Le formateur indiquera sa plage de disponibilité.',
    icon: 'fas fa-calendar-alt',
    testId: 'publier-mission-mode-periode',
  },
]
